import React from 'react'
import { QuestionsWrapper } from './styles'
import { Header2, Text } from '../../styles/Components'

const Questions = () => {
  return (
    <QuestionsWrapper>
      <Header2 margin="0 0 18px 0">Let&apos;s Chat</Header2>
      <Text fontSize={20}>
        Have questions or want to pitch a collaboration? Drop us a line at{' '}
        <a href="mailto:ambassadors@glamsquad.com">
          ambassadors@glamsquad.com
        </a>
        .
      </Text>
      <div className="please-note">
        <Text weight={700} fontSize={18}>
          PLEASE NOTE: Bidding on keywords such as
          “glamsquad,”, “Glamsquad,” or “Glam squad
          and similar terms, as well as promoting
          Glamsquad services inpaid ad placements 
          is prohibited and will result in termination.
        </Text>
      </div>
    </QuestionsWrapper>
  )
}

export default Questions
